export default "__VITE_ASSET__DwaavU3g__"